import React from 'react';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';
import CheckBox from '@spark/ui-components/components/form/CheckBox';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';

export const getAssociacaoVeiculoColumns = ({
  selectedIds,
  onToggleSelect,
  onToggleSelectAll,
  allPageSelected,
  selectAllDisabled,
  onGerenciar
}) => {
  const selectionHeader = (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <Tooltip dir="top" text={allPageSelected ? 'Remover seleção da página' : 'Selecionar página'}>
        <span className="d-inline-flex align-items-center">
          <CheckBox
            name="select-all-associacao-veiculos"
            checked={!!allPageSelected}
            disabled={!!selectAllDisabled}
            label=""
            onChange={(event) => {
              event.stopPropagation();
              onToggleSelectAll();
            }}
            onClick={(event) => event.stopPropagation()}
          />
        </span>
      </Tooltip>
      <span>Sel.</span>
    </div>
  );

  return [
    {
      id: 'select',
      header: () => selectionHeader,
      size: 70,
      enableSorting: false,
      enableCopy: false,
      cell: ({ row }) => {
        const rowId = row.original.id;
        const isSelected = selectedIds?.includes(rowId);
        return (
          <CheckBox
            name={`select-associacao-veiculo-${rowId}`}
            checked={!!isSelected}
            label=""
            onChange={(event) => {
              event.stopPropagation();
              onToggleSelect(rowId);
            }}
            onClick={(event) => event.stopPropagation()}
          />
        );
      }
    },
    {
      id: 'numeroFrota',
      header: 'Número Frota',
      accessorKey: 'numeroFrota',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={14} />
    },
    {
      id: 'placa',
      header: 'Placa',
      accessorKey: 'placa',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={12} />
    },
    {
      id: 'modelo',
      header: 'Modelo',
      accessorKey: 'modelo',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={22} />
    },
    {
      id: 'segmento',
      header: 'Segmento',
      accessorKey: 'segmento',
      cell: ({ getValue }) => <TruncatedText value={getValue() || '-'} maxLength={18} />
    },
    {
      id: 'acoes',
      header: 'Ações',
      size: 100,
      enableSorting: false,
      enableCopy: false,
      cell: ({ row }) => (
        <Tooltip dir="top" text="Gerenciar frota">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={(event) => {
              event.stopPropagation();
              onGerenciar(row.original);
            }}
          >
            <Icon name="settings" size={16} />
          </Button>
        </Tooltip>
      )
    }
  ];
};
